import { d as debounce } from './debounce-CFN_LA0O.js';
import { C as Cart } from './cart--s-Nwx-s.js';
import { P as Pubsub } from './pubsub-DKqIEqaC.js';
import { N as Notyf } from './notyf-DIw0RvBj.js';

class CartItem extends HTMLElement {
  unsubscribers = [];
  lineItemIndex = this.dataset.lineItemIndex;
  removeButton = this.querySelector('[data-line-item-remove]');
  loadingOverlay = this.querySelector('.loading-overlay');

  connectedCallback() {
    this.removeButton.addEventListener('click', (event) => this.handleRemove(event));
    this.unsubscribers.push(
      Pubsub.subscribe('quantity:change', ({ line, quantity }) =>
        this.handleQuantityChange(line, quantity)
      )
    );
  }

  disconnectedCallback() {
    this.unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * @description Handle the remove button click event
   * @param {Event} event - The event object
   */
  async handleRemove(event) {
    event.preventDefault();

    this.handleLoading(true);

    try {
      await Cart.change({
        line: this.lineItemIndex,
        quantity: 0,
      });
    } catch (error) {
      console.error("Couldn't remove item", error);
      Notyf.error(window.toast_translations.cart.remove_error);
    } finally {
      this.handleLoading(false);
    }
  }

  /**
   * @description Handle the quantity change event
   * @param {number} line - The line item index
   * @param {number} quantity - The quantity
   */
  handleQuantityChange = debounce(async (line, quantity) => {
    if (line !== this.lineItemIndex) return;

    this.handleLoading(true);

    try {
      await Cart.change({
        line: this.lineItemIndex,
        quantity,
      });
    } catch (error) {
      console.error("Couldn't update quantity", error);
      Notyf.error(window.toast_translations.cart.quantity_error);
    } finally {
      this.handleLoading(false);
    }
  }, 300);

  /**
   * @description Handle the loading overlay
   * @param {boolean} loading - The loading state
   */
  handleLoading(loading) {
    this.loadingOverlay.ariaHidden = !loading;
  }
}

customElements.define('line-item', CartItem);
